module.exports = __webpack_public_path__ + "media/images/icon__search--rb-white@3x-179d8ed109d0f02e9fdfbdb303747d16.png";